
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-pokemon-blue/10 py-8 mt-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-3 text-pokemon-blue">PokeScan</h3>
            <p className="text-sm text-gray-600">
              The ultimate Pokemon card valuation tool with card scanning technology. 
              Find the value of your cards instantly!
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-3 text-pokemon-blue">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>Home</span>
                </Link>
              </li>
              <li>
                <Link to="/scan" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>Scan Card</span>
                </Link>
              </li>
              <li>
                <Link to="/collection" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>Collection</span>
                </Link>
              </li>
              <li>
                <Link to="/profile" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>User Profile</span>
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-3 text-pokemon-blue">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/pricing-guide" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>Pricing Guide</span>
                </Link>
              </li>
              <li>
                <Link to="/rarity-guide" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>Rarity Guide</span>
                </Link>
              </li>
              <li>
                <Link to="/collector-tips" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>Collector Tips</span>
                </Link>
              </li>
              <li>
                <Link to="/faq" className="footer-link text-gray-600 hover:text-pokemon-blue flex items-center">
                  <span>FAQs</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-8 pt-6 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} PokeScan. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
